import { get } from "src/services/HttpClient";

export async function getData(handler = () => { }, url, config, signal) {
    const result = await get(url, config, signal);
    if (result && result.success) {
        handler(result.body);
        return result.body;
    }
    return result;
}